/**
 * ResetConfirmModal Component
 *
 * Confirmation dialog shown before resetting/archiving the tracker.
 * Explicitly communicates that notes and history are preserved, and
 * shows the current completed step count to reduce accidental resets.
 */

import React from 'react'
import { observer } from 'mobx-react-lite'
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBIcon,
} from 'mdb-react-ui-kit'
import Store from '../../FirstSaleTracker.store'

const ResetConfirmModal = () => {
  const { showResetConfirm, closeResetConfirm, resetTracker, completedCount, saving } = Store

  return (
    <MDBModal open={showResetConfirm} onClose={closeResetConfirm} tabIndex='-1'>
      <MDBModalDialog centered>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>
              <MDBIcon icon='redo-alt' className='mr-2 text-warning' />
              Reset Your Tracker
            </MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={closeResetConfirm}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <p>
              This will archive your current progress and start a new tracker. Your notes and history will be preserved.
            </p>
            {completedCount > 0 && (
              <p className='mb-0 text-muted'>
                <strong>You have completed {completedCount} of 8 steps.</strong>
              </p>
            )}
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type='button' color='flat' onClick={closeResetConfirm} disabled={saving}>
              Cancel
            </MDBBtn>
            <MDBBtn type='button' color='danger' onClick={resetTracker} disabled={saving}>
              {saving ? 'Resetting...' : 'Reset Progress'}
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

export default observer(ResetConfirmModal)
